<div class="container">
	<div class="inner-content-box">
		<div class="row">
			<div class="col-xs-12 col-md-8">
			Please select an account or application to continue..
			</div>
		</div>
		{{#each users}}
		<div class="row bg-primary" style="margin: 20px 0 10px 0; padding: 10px;">
			<div class="col-md-2">Account:</div>
			<div class="col-md-2">{{forename}} {{surname}}</div>
			<div class="col-md-2">{{username}}</div>
			<div class="col-md-6 bg-default">Home App: <a style="color: #fff;" href="{{myWebApp.urlWithoutContextPath}}/{{myWebApp.contextPath}}">{{myWebApp.urlWithoutContextPath}}/{{myWebApp.contextPath}}</a></div>
		</div>
		<div class="row" style="padding: 10px;">
			<div class="col-md-2">Apps I share with..</div>
			<div class="col-md-10">
				{{#each inPartners}}
				<div class="row">
					<div class="col-md-12"><a href="{{urlWithoutContextPath}}/{{contextPath}}">{{urlWithoutContextPath}}/{{contextPath}}</a></div>
				</div>
				{{/each}}
			</div> 
		</div>
<!-- 				<div class="row"> -->
<!-- 					<div class="col-md-2 col-md-offset-2">Apps which share with me..</div> -->
<!-- 					{{#each outPartners}} -->
<!-- 					<div class="row"> -->
<!-- 						<div class="col-md-12"><a href="{{urlWithoutContextPath}}/{{contextPath}}">{{urlWithoutContextPath}}/{{contextPath}}</a></div> -->
<!-- 					</div> -->
<!-- 					{{/each}} -->
<!-- 				</div> -->
		{{/each}}
	</div>
</div>
